export default __webpack_public_path__ + "static/img-zombit-b3700e5aefcebd4af014657f96c823e5.png";